import { z } from 'zod';

export const libraryRequestSchema = z.object({
  name: z.string().nonempty('This field is obligatory'),
  email: z.string().nonempty('This field is obligatory').email('Wrong mail format'),
  marketingAgree: z.boolean().refine((value) => value === true, 'This field is obligatory'),
});
